import React from "react";
import { Link } from "react-router-dom";

const Safety = () => {
  return (
    <div className="legal-page page-shell">
      <div className="card legal-card">
        <h1>Safety Guidelines</h1>
        <p className="muted">Last updated: May 4, 2026</p>

        <p>
          Farm work, rural property work, local selling, events, equipment,
          animals, weather, and travel can all involve risk. These guidelines
          are not legal, medical, veterinary, or safety advice. They are general
          reminders to help users make careful decisions.
        </p>

        <h2>1. Use Your Judgment</h2>
        <p>
          Review profiles, listings, reviews, messages, locations, and details
          before agreeing to meet, work, buy, sell, or reserve a spot. If
          something feels wrong, do not proceed.
        </p>

        <h2>2. Meet Carefully</h2>
        <p>
          When possible, meet in safe, public, well-lit places. Tell someone
          where you are going. Avoid sharing unnecessary personal information.
        </p>

        <h2>3. Verify Work Details</h2>
        <p>
          Before starting a job, users should discuss the work area, pay or bid
          amount, timeline, equipment, hazards, access, animals, chemicals,
          terrain, weather, emergency contacts, and expectations.
        </p>

        <h2>4. Equipment and Qualifications</h2>
        <p>
          Do not operate equipment, handle animals, transport goods, apply
          chemicals, or perform specialized work unless you are qualified,
          trained, legally allowed, and properly equipped.
        </p>

        <h2>5. Insurance and Legal Requirements</h2>
        <p>
          Users are responsible for checking whether insurance, permits,
          licenses, tax reporting, contracts, safety rules, or other legal
          requirements apply to their work, products, events, or transactions.
        </p>

        <h2>6. Teen and Summer Work Safety</h2>
        <p>
          MyFarmingPal accounts are for adults. If a parent or legal guardian
          uses their own adult account to help a teenager find local work, the
          adult is responsible for reviewing the opportunity, communicating with
          the other party, supervising or approving the arrangement, and making
          sure the work is safe, legal, and appropriate.
        </p>

        <p>
          Before any teenager begins work, parents, guardians, and hiring parties
          should discuss the work location, schedule, pay, transportation,
          equipment, hazards, animals, chemicals, machinery, weather, emergency
          contacts, and applicable labor or child labor rules. MyFarmingPal does
          not supervise, approve, insure, or manage work arrangements.
        </p>

        <h2>7. Product Safety</h2>
        <p>
          Buyers should ask questions and inspect goods before purchase. Sellers
          are responsible for honest descriptions, safe handling, legal
          compliance, labeling where required, and accurate availability.
        </p>

        <h2>8. Event Safety</h2>
        <p>
          Event hosts are responsible for venue safety, booth areas, crowd flow,
          weather planning, parking, permits, payments, and vendor rules.
          Vendors should confirm event details before attending.
        </p>

        <h2>9. Emergencies</h2>
        <p>
          MyFarmingPal is not an emergency service. In an emergency, contact
          local emergency services immediately.
        </p>

        <h2>10. Report Concerns</h2>
        <p>
          Report suspicious, unsafe, abusive, or illegal activity through our{" "}
          <Link to="/contact">Contact page</Link>.
        </p>
      </div>
    </div>
  );
};

export default Safety;
